import axios from 'axios';

// Auto-detect backend URL: use env variable or fallback to current origin
const getBackendUrl = () => {
  // If env variable is set and not empty, use it
  if (process.env.REACT_APP_BACKEND_URL && process.env.REACT_APP_BACKEND_URL.trim()) {
    return process.env.REACT_APP_BACKEND_URL.trim();
  }
  // In production, use the same origin (frontend and backend on same domain)
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  // Fallback for SSR or other cases
  return '';
};

const BACKEND_URL = getBackendUrl();

const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors (token expired)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      localStorage.removeItem('token');
      // Only redirect if not already on auth pages
      if (!['/login', '/register'].includes(window.location.pathname)) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { BACKEND_URL };
